export default __webpack_public_path__ + "static/media/arrow.b8d8df85.png";